// Login + forced-password-change screens, ported from source's
// setupLoginUI/enterApp (lines 3101-3239), now hitting the auth service
// through the gateway instead of the in-memory USERS store.
import { authApi, setToken, clearToken } from "./api-client.js";
import { $, hideError, showError } from "./dom.js";
import { STATE } from "./state.js";
import { validatePasswordStrength } from "@woof/shared";
import { enterApp } from "./main.js";

function showLoginPage(): void {
  $("#loginPage")!.classList.remove("hidden");
  $("#app")!.classList.add("hidden");
}

export function showLoginView(): void {
  $("#loginView")!.classList.remove("hidden");
  $("#changePwdView")!.classList.add("hidden");
}

function showChangePwdView(requireOld: boolean): void {
  $("#loginView")!.classList.add("hidden");
  $("#changePwdView")!.classList.remove("hidden");
  $("#cpOldGroup")!.classList.toggle("hidden", !requireOld);
  ($("#cpIntro") as HTMLElement).textContent = requireOld
    ? "Entrez votre mot de passe actuel puis votre nouveau mot de passe."
    : "Première connexion : choisissez votre mot de passe permanent.";
}

async function doLogin(): Promise<void> {
  const username = ($("#loginUser") as HTMLInputElement).value.trim();
  const password = ($("#loginPwd") as HTMLInputElement).value;
  const errEl = $("#loginError")!;
  hideError(errEl);
  if (!username || !password) {
    showError(errEl, "Identifiant et mot de passe requis.");
    return;
  }
  try {
    const { token, user } = await authApi.login(username, password);
    setToken(token);
    if (user.mustChangePassword) {
      STATE.user = { id: user.id, username: user.username, role: user.role, sites: user.sites, fullName: user.fullName, mustChangePassword: true };
      showChangePwdView(false);
      return;
    }
    STATE.user = { id: user.id, username: user.username, role: user.role, sites: user.sites, fullName: user.fullName, mustChangePassword: false };
    enterApp();
  } catch (err) {
    showError(errEl, err instanceof Error ? err.message : "Erreur de connexion");
  }
}

async function doChangePassword(): Promise<void> {
  const oldPwd = ($("#cpOld") as HTMLInputElement).value;
  const new1 = ($("#cpNew1") as HTMLInputElement).value;
  const new2 = ($("#cpNew2") as HTMLInputElement).value;
  const errEl = $("#cpError")!;
  const okEl = $("#cpSuccess")!;
  hideError(errEl);
  hideError(okEl);

  if (new1 !== new2) {
    showError(errEl, "Les deux mots de passe ne correspondent pas.");
    return;
  }
  const strengthError = validatePasswordStrength(new1);
  if (strengthError) {
    showError(errEl, strengthError);
    return;
  }
  try {
    await authApi.changePassword({ oldPassword: oldPwd || undefined, newPassword: new1 });
    okEl.textContent = "Mot de passe mis à jour. Vous pouvez continuer.";
    okEl.classList.remove("hidden");
    if (STATE.user) STATE.user.mustChangePassword = false;
    setTimeout(() => enterApp(), 600);
  } catch (err) {
    showError(errEl, err instanceof Error ? err.message : "Erreur");
  }
}

export function logout(): void {
  clearToken();
  STATE.user = null;
  showLoginPage();
  showLoginView();
}

export function setupLoginUI(): void {
  $("#btnLogin")!.addEventListener("click", doLogin);
  $("#loginPwd")!.addEventListener("keydown", (e) => {
    if ((e as KeyboardEvent).key === "Enter") doLogin();
  });
  $("#btnChangePwd")!.addEventListener("click", doChangePassword);
  $("#btnLogout")!.addEventListener("click", logout);
}

export { showLoginPage };
